export enum OrderPlacementType {
  Buy = 'BUY',
  Sell = 'SELL',
}
